import React from 'react'

import styled from 'styled-components'
import { COLORS, TYPOGRAPHY } from 'utils'

export type SpanStyleProps = {
  color?: string
  fontSize?: string
  fontWeight?: string
  textAlign?: string
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  cursor?: string
  textTransform?: React.CSSProperties['textTransform']
}

export const CustomSpan = styled.span<SpanStyleProps>`
  color: ${({ color }) => color || COLORS.black};
  font-family: Arial, Helvetica, sans-serif;
  font-size: ${({ fontSize }) => fontSize || TYPOGRAPHY.bodySize14};
  font-weight: ${({ fontWeight }) => fontWeight};
  text-align: ${({ textAlign }) => textAlign};
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor }) => cursor};
  ${({ textTransform }) => `text-transform:${textTransform}`};
`
